import {
  getAllCategories,
  createCategory,
  updateCategory,
  deleteCategory
} from 'services/categoryService';
import {
  getCategoriesStart,
  getCategoriesSuccess,
  getCategoriesFailure,
  createCategoryStart,
  createCategorySuccess,
  createCategoryFailure,
  updateCategoryStart,
  updateCategorySuccess,
  updateCategoryFailure,
  deleteCategoryStart,
  deleteCategorySuccess,
  deleteCategoryFailure
} from 'store/features/category/categorySlice';

export const fetchCategories = () => async (dispatch) => {
  try {
    dispatch(getCategoriesStart());
    const response = await getAllCategories();
    dispatch(getCategoriesSuccess(response.data));
  } catch (error) {
    dispatch(getCategoriesFailure(error.message));
  }
};

export const addCategory = (categoryData) => async (dispatch) => {
  try {
    dispatch(createCategoryStart());
    const response = await createCategory(categoryData);
    dispatch(createCategorySuccess(response.data));
  } catch (error) {
    dispatch(createCategoryFailure(error.message));
  }
};

export const modifyCategory = (categoryId, updateData) => async (dispatch) => {
  try {
    dispatch(updateCategoryStart());
    const response = await updateCategory(categoryId, updateData);
    dispatch(updateCategorySuccess(response.data));
  } catch (error) {
    dispatch(updateCategoryFailure(error.message));
  }
};

export const removeCategory = (categoryId) => async (dispatch) => {
  try {
    dispatch(deleteCategoryStart());
    await deleteCategory(categoryId);
    dispatch(deleteCategorySuccess(categoryId));
  } catch (error) {
    dispatch(deleteCategoryFailure(error.message));
  }
};